const E = {
  CLIENTS: 'CLIENTS',
  'View All': 'View All',
  Pinned: 'Pinned',
  Show: 'Show',
  Projects: 'Projects',
  Fewer: 'Fewer',
  More: 'More',
  'Contact Us': 'Contact Us',
};

const F = {
  CLIENTS: 'CLIENTS',
  'View All': 'Voir tout',
  Pinned: 'Épinglé',
  Show: 'Afficher',
  Projects: 'Projets',
  Fewer: 'Afficher moins',
  More: 'Afficher plus',
  'Contact Us': 'Nous contacter',
};

export default { E, F };



// WEBPACK FOOTER //
// ./src/constants/translations/nav.js